// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1Iy89","checkboxCol":"Table_checkboxCol__2opsR","emailCol":"Table_emailCol__2WEc9","actionCol":"Table_actionCol__1iHV2"};